import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Message from 'components/Message';

const Bar = ({ reservations, capacity, isDisabled = false, noColor = false }) => {
  const displayPercent = reservations === 0 ? 0 : reservations / capacity;
  const stylePercent = Math.ceil(displayPercent * 100);
  const diff = capacity - reservations;
  const barClasses = classNames({
    opportunity__bar: true,
    'opportunity__bar--disabled': isDisabled,
  });
  const fillClasses = classNames({
    'opportunity__bar-fill': true,
    'opportunity__bar-fill--full': !noColor && !isDisabled && diff === 0,
    'opportunity__bar-fill--warn': !noColor && !isDisabled && diff === 1,
    'opportunity__bar-fill--open': !noColor && !isDisabled && diff > 1,
    'opportunity__bar-fill--disabled': isDisabled,
  });
  const percentClasses = classNames({
    'opportunity__bar-percent': true,
    'opportunity__bar-percent--inside': stylePercent > 50,
    'opportunity__bar-percent--outside': stylePercent <= 50,
    'opportunity__bar-percent--disabled': isDisabled,
  });

  return (
    <div className={barClasses}>
      <span className={fillClasses} style={{ width: `${stylePercent}%` }} />
      <span className={percentClasses}>
        <Message format="percent" value={displayPercent} />
      </span>
    </div>
  );
};

Bar.propTypes = {
  reservations: PropTypes.number.isRequired,
  capacity: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
  noColor: PropTypes.bool,
};

export default Bar;
